import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      hero_title: 'Room reservations made simple',
      cta_login: 'Sign in',
      cta_explore: 'Explore rooms',
      cta_contact: 'Contact us',
      features_title: 'Why choose us',
      f_realtime: 'Real‑time availability and conflict detection',
      f_recurring: 'Recurring bookings with exceptions',
      f_calendar: 'Google Calendar sync',
      f_access: 'Roles & access control',
      nav_home: 'Home',
      nav_rooms: 'Rooms',
      theme_system: 'System',
      theme_light: 'Light',
      theme_dark: 'Dark',
      lang_en: 'English',
      lang_fa: 'Persian',
      login_title: 'Login',
      username_label: 'Username:',
      password_label: 'Password:',
      login_button: 'Login',
      login_oauth: 'Login with OAuth',
      login_error: 'Invalid username or password',
      logout_button: 'Logout',
      signed_in_as: 'Signed in as',
      theme: 'Theme',
      language: 'Language',
      management_panel: 'Management panel',
      select_resource_group: 'Select Resource Group',
      floor_plan: 'Floor plan',
      previous: 'Previous',
      next: 'Next',
      create_event: 'Create Event',
      reservation_success: 'Reservation Successful',
      loading: 'Loading...',

      // Contact us
      contact_title: 'Contact us',
      contact_subtitle: "Tell us about your needs. We'll get back within 1 business day.",
      contact_name: 'Name',
      contact_email: 'Email',
      contact_phone: 'Phone number',
      contact_company: 'Company',
      contact_message: 'Message',
      contact_website: 'Website',
      contact_sending: 'Sending...',
      contact_send: 'Send',
      contact_success: 'Your message has been sent successfully!',
      contact_error: 'Failed to send message. Please try again.',
      contact_network_error: 'Network error. Please check your connection and try again.',

      // Modal - Create/Edit Event
      modal_edit_event: 'Edit Event',
      modal_create_event: 'Create Event',
      modal_event_name: 'Event Name:',
      modal_room: 'Room:',
      modal_start_time: 'Start Time:',
      modal_end_time: 'End Time:',
      modal_description: 'Description:',
      modal_repeat: 'Repeat',
      modal_frequency: 'Frequency:',
      modal_frequency_select: 'Select',
      modal_frequency_daily: 'Daily',
      modal_frequency_weekly: 'Weekly',
      modal_frequency_monthly: 'Monthly',
      modal_repeat_on: 'Repeat on:',
      modal_interval: 'Interval:',
      modal_interval_hint: '(e.g. every 2 weeks)',
      modal_ends: 'Ends:',
      modal_ends_never: 'Never',
      modal_ends_after: 'After N occurrences',
      modal_ends_until: 'On date',
      modal_cancel: 'Cancel',
      modal_save: 'Save',
      modal_error_weekly: 'Please select at least one day for weekly recurrence.',
      modal_error_save: 'An error occurred while saving the event. Please try again.',

      // Weekdays
      weekday_sat: 'Sat',
      weekday_sun: 'Sun',
      weekday_mon: 'Mon',
      weekday_tue: 'Tue',
      weekday_wed: 'Wed',
      weekday_thu: 'Thu',
      weekday_fri: 'Fri',

      // Reservation Details
      details_title: 'Reservation Details',
      details_title_label: 'Title:',
      details_reserved_by: 'Reserved by:',
      details_description: 'Description:',
      details_no_description: 'No description provided',
      details_recurrence: 'Recurrence:',
      details_start_time: 'Start Time:',
      details_end_time: 'End Time:',
      details_close: 'Close',
      details_edit: 'Edit',
      details_delete: 'Delete Reservation',
      details_deleting: 'Deleting...',
      details_delete_error: 'Failed to delete reservation',

      // Timeline
      timeline_rooms: 'Rooms',
      timeline_capacity: 'Capacity:',
      timeline_reserving_by: 'Reservation in progress by',
      timeline_reserving: 'Reserving...',
      timeline_reserved: 'Reserved',

      // Room List
      rooms_available: 'Available Rooms',
      rooms_click_details: 'Click to view details',

      // Default values
      default_event_name: 'Meeting',

      // Calendar - Gregorian Months
      month_january: 'January',
      month_february: 'February',
      month_march: 'March',
      month_april: 'April',
      month_may: 'May',
      month_june: 'June',
      month_july: 'July',
      month_august: 'August',
      month_september: 'September',
      month_october: 'October',
      month_november: 'November',
      month_december: 'December',

      // Calendar - Days
      day_sat: 'Sat',
      day_sun: 'Sun',
      day_mon: 'Mon',
      day_tue: 'Tue',
      day_wed: 'Wed',
      day_thu: 'Thu',
      day_fri: 'Fri',

      // Persian Calendar Months (Solar Hijri)

      persian_month_1: 'Farvardin',
      persian_month_2: 'Ordibehest',
      persian_month_3: 'Khordad',
      persian_month_4: 'Tir',
      persian_month_5: 'Mordad',
      persian_month_6: 'Shahrivar',
      persian_month_7: 'Mehr',
      persian_month_8: 'Aban',
      persian_month_9: 'Azar',
      persian_month_10: 'Dey',
      persian_month_11: 'Bahman',
      persian_month_12: 'Esfehan',

      // Room Page
      room_exit: 'Exit Room',
      room_occupied: 'The room is occupied',
      room_title_label: 'Title:',
      room_start_label: 'Start:',
      room_end_label: 'End:',
      room_reserved_by: 'Reserved by:',
      room_end_meeting: 'End Meeting Now',
      room_reserve_after: 'Reserve After Current Event',
      room_reserve_title: 'Reserve the Room',
      room_event_name: 'Event Name:',
      room_reserve_button: 'Reserve',
      room_upcoming_events: 'Upcoming Events',
      room_no_upcoming: 'No upcoming events',
      room_another_user_selecting: 'Another user is selecting a time in this room...',
      room_error_reserve: 'Failed to reserve. Please try again.',
      room_error_cancel: 'Failed to cancel the event.',
      room_success_title: 'Reservation Successful',
      room_success_message: 'Your reservation has been created.',
      room_close: 'Close'
    }
  },
  fa: {
    translation: {
      hero_title: 'رزرو اتاق به‌سادگی',
      cta_login: 'ورود',
      cta_explore: 'مشاهده اتاق‌ها',
      cta_contact: 'تماس با ما',
      features_title: 'چرا ما',
      f_realtime: 'دسترسی لحظه‌ای و تشخیص تداخل',
      f_recurring: 'رزروهای تکرارشونده با استثناها',
      f_calendar: 'همگام‌سازی با گوگل کلندر',
      f_access: 'نقش‌ها و کنترل دسترسی',
      nav_home: 'خانه',
      nav_rooms: 'اتاق‌ها',
      theme_system: 'سیستم',
      theme_light: 'روشن',
      theme_dark: 'تاریک',
      lang_en: 'انگلیسی',
      lang_fa: 'فارسی',
      login_title: 'ورود',
      username_label: 'نام کاربری:',
      password_label: 'رمز عبور:',
      login_button: 'ورود',
      login_oauth: 'ورود با OAuth',
      login_error: 'نام کاربری یا رمز عبور نامعتبر',
      logout_button: 'خروج',
      signed_in_as: 'وارد شده به عنوان',
      theme: 'تم',
      language: 'زبان',
      management_panel: 'پنل مدیریت',
      select_resource_group: 'انتخاب گروه منابع',
      floor_plan: 'نقشه طبقه',
      previous: 'قبلی',
      next: 'بعدی',
      create_event: 'ایجاد رویداد',
      reservation_success: 'رزرو با موفقیت انجام شد',
      loading: 'در حال بارگذاری...',

      // Contact us
      contact_title: 'تماس با ما',
      contact_subtitle: 'نیازهای خود را به ما بگویید. ما ظرف ۱ روز کاری پاسخ خواهیم داد.',
      contact_name: 'نام',
      contact_email: 'ایمیل',
      contact_phone: 'شماره تماس',
      contact_company: 'شرکت',
      contact_message: 'پیام',
      contact_website: 'وب‌سایت',
      contact_sending: 'در حال ارسال...',
      contact_send: 'ارسال',
      contact_success: 'پیام شما با موفقیت ارسال شد!',
      contact_error: 'ارسال پیام ناموفق بود. لطفاً دوباره تلاش کنید.',
      contact_network_error: 'خطای شبکه. لطفاً اتصال خود را بررسی کرده و دوباره تلاش کنید.',

      // Modal - Create/Edit Event
      modal_edit_event: 'ویرایش رویداد',
      modal_create_event: 'ایجاد رویداد',
      modal_event_name: 'نام رویداد:',
      modal_room: 'اتاق:',
      modal_start_time: 'زمان شروع:',
      modal_end_time: 'زمان پایان:',
      modal_description: 'توضیحات:',
      modal_repeat: 'تکرار',
      modal_frequency: 'تناوب:',
      modal_frequency_select: 'انتخاب کنید',
      modal_frequency_daily: 'روزانه',
      modal_frequency_weekly: 'هفتگی',
      modal_frequency_monthly: 'ماهانه',
      modal_repeat_on: 'تکرار در:',
      modal_interval: 'فاصله:',
      modal_interval_hint: '(مثال: هر ۲ هفته)',
      modal_ends: 'پایان:',
      modal_ends_never: 'هرگز',
      modal_ends_after: 'بعد از N بار تکرار',
      modal_ends_until: 'تا تاریخ',
      modal_cancel: 'انصراف',
      modal_save: 'ذخیره',
      modal_error_weekly: 'لطفاً حداقل یک روز برای تکرار هفتگی انتخاب کنید.',
      modal_error_save: 'خطایی در ذخیره رویداد رخ داد. لطفاً دوباره تلاش کنید.',

      // Weekdays
      weekday_sat: 'شنبه',
      weekday_sun: 'یکشنبه',
      weekday_mon: 'دوشنبه',
      weekday_tue: 'سه‌شنبه',
      weekday_wed: 'چهارشنبه',
      weekday_thu: 'پنج‌شنبه',
      weekday_fri: 'جمعه',

      // Reservation Details
      details_title: 'جزئیات رزرو',
      details_title_label: 'عنوان:',
      details_reserved_by: 'رزرو شده توسط:',
      details_description: 'توضیحات:',
      details_no_description: 'توضیحاتی ارائه نشده است',
      details_recurrence: 'تکرار:',
      details_start_time: 'زمان شروع:',
      details_end_time: 'زمان پایان:',
      details_close: 'بستن',
      details_edit: 'ویرایش',
      details_delete: 'حذف رزرو',
      details_deleting: 'در حال حذف...',
      details_delete_error: 'حذف رزرو ناموفق بود',

      // Timeline
      timeline_rooms: 'اتاق‌ها',
      timeline_capacity: 'ظرفیت:',
      timeline_reserving_by: 'رزرو در حال انجام توسط',
      timeline_reserving: 'در حال رزرو...',
      timeline_reserved: 'رزرو شده',

      // Room List
      rooms_available: 'اتاق‌های موجود',
      rooms_click_details: 'برای مشاهده جزئیات کلیک کنید',

      // Default values
      default_event_name: 'جلسه',

      // Calendar - Gregorian Months (in Persian)
      month_january: 'ژانویه',
      month_february: 'فوریه',
      month_march: 'مارس',
      month_april: 'آوریل',
      month_may: 'می',
      month_june: 'ژوئن',
      month_july: 'ژوئیه',
      month_august: 'اوت',
      month_september: 'سپتامبر',
      month_october: 'اکتبر',
      month_november: 'نوامبر',
      month_december: 'دسامبر',

      // Calendar - Days
      day_sat: 'ش',
      day_sun: 'ی',
      day_mon: 'د',
      day_tue: 'س',
      day_wed: 'چ',
      day_thu: 'پ',
      day_fri: 'ج',

      // Persian Calendar Months (Solar Hijri)
      persian_month_1: 'فروردین',
      persian_month_2: 'اردیبهشت',
      persian_month_3: 'خرداد',
      persian_month_4: 'تیر',
      persian_month_5: 'مرداد',
      persian_month_6: 'شهریور',
      persian_month_7: 'مهر',
      persian_month_8: 'آبان',
      persian_month_9: 'آذر',
      persian_month_10: 'دی',
      persian_month_11: 'بهمن',
      persian_month_12: 'اسفند',

      // Room Page
      room_exit: 'خروج از اتاق',
      room_occupied: 'اتاق اشغال شده است',
      room_title_label: 'عنوان:',
      room_start_label: 'شروع:',
      room_end_label: 'پایان:',
      room_reserved_by: 'رزرو شده توسط:',
      room_end_meeting: 'اتمام جلسه',
      room_reserve_after: 'رزرو بعد از رویداد جاری',
      room_reserve_title: 'رزرو اتاق',
      room_event_name: 'نام رویداد:',
      room_reserve_button: 'رزرو',
      room_upcoming_events: 'رویدادهای آینده',
      room_no_upcoming: 'رویداد آینده‌ای وجود ندارد',
      room_another_user_selecting: 'کاربر دیگری در حال انتخاب زمان در این اتاق است...',
      room_error_reserve: 'رزرو ناموفق بود. لطفاً دوباره تلاش کنید.',
      room_error_cancel: 'لغو رویداد ناموفق بود.',
      room_success_title: 'رزرو موفق',
      room_success_message: 'رزرو شما ایجاد شد.',
      room_close: 'بستن'
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: { escapeValue: false }
  });

// Set initial direction based on detected language
const setDirection = (lng) => {
  try {
    const html = document.documentElement;
    const isRtl = lng === 'fa';
    html.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
    html.setAttribute('lang', lng);
  } catch {}
};

// Set direction on initial load
setDirection(i18n.language || i18n.options.fallbackLng);

i18n.on('languageChanged', (lng) => {
  setDirection(lng);
});

export default i18n;
